import React from "react"
import { PhoneNumberCollectionModal } from "../account/PhoneNumberCollectionModal"
import { CarrotPlansGatedAccountContainer } from "../../carrot-plans/case-rate-renewals/CarrotPlansGatedAccountModal"
import { useGetCaseRateRenewalStatus } from "../../carrot-plans/case-rate-renewals/useQueryCaseRateRenewals"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useCurrentUser } from "../../context/user/UserContext"
import Locations from "../home/navigation"
import { useUserRole } from "../../partner-access/hooks/usePartnerAccess"
import { CarrotPlanModal } from "components/carrot-plans/CarrotPlansModal"
import useCarrotPlanEmployeeSettings from "components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"
import { getCarrotModalStorage, updateCarrotModalStorage } from "./utils/localStorageUtils"

export function AppLoginModalContainer(): JSX.Element {
  const carrotModalStorage = getCarrotModalStorage()
  const { phoneNumber, dismissedPhoneNumberFeatureModal, showRegPreCarrotPlansSoftLaunchFeatures } = useCurrentUser()
  const { data: CpesData, isLoading: isCpesLoading } = useCarrotPlanEmployeeSettings()
  const { showPhoneCollectionModal } = useFlags()
  const {
    isLoading: isCrrLoading,
    showAdvancedCheckInFeatures,
    shouldCrrModalRender,
    isCrrAdvancedCheckIn
  } = useGetCaseRateRenewalStatus()
  const { isPartnerAccessingAccount, isUserRoleLoading } = useUserRole()
  const isDataLoading = isCrrLoading || isUserRoleLoading || isCpesLoading

  const isOnDefaultLandingPage =
    window.location.pathname === Locations.Home.Index.pathname && window.location.hash !== "#needs-benefit-enrollment"

  const shouldRenderPhoneNumberModal =
    showPhoneCollectionModal &&
    !isPartnerAccessingAccount &&
    !shouldCrrModalRender &&
    !carrotModalStorage?.hasCrrModalTriggeredThisSession &&
    !dismissedPhoneNumberFeatureModal &&
    !phoneNumber
  const shouldRenderCarrotPlanModal =
    !CpesData?.acknowledgedCarrotPlanPopupAt && showRegPreCarrotPlansSoftLaunchFeatures
  const shouldAnyModalRender = shouldCrrModalRender || shouldRenderPhoneNumberModal || shouldRenderCarrotPlanModal

  if (!carrotModalStorage?.hasCrrModalTriggeredThisSession) {
    updateCarrotModalStorage(shouldCrrModalRender)
  }

  if (isDataLoading) {
    return null
  }

  if (shouldAnyModalRender && isOnDefaultLandingPage) {
    if (shouldCrrModalRender) {
      return (
        <CarrotPlansGatedAccountContainer
          shouldCrrModalRender={shouldCrrModalRender}
          showAdvancedCheckInFeatures={showAdvancedCheckInFeatures}
          isCrrAdvancedCheckIn={isCrrAdvancedCheckIn}
        />
      )
    }

    if (shouldRenderCarrotPlanModal) {
      return <CarrotPlanModal />
    }

    if (shouldRenderPhoneNumberModal) {
      return <PhoneNumberCollectionModal />
    }
  }

  return null
}
